import React from 'react';
import { formatMinistryMonthLabel } from '../../utils/mbcbReportPeriodLabels';
import { AiAssistPill, NarrativeField } from './EditorShell';
import { RevisionNotesBanner } from './RevisionNotesBanner';

interface StepPeopleProps {
  ministryMonth: number;
  ministryYear: number;
  ministryHighlights: string;
  setMinistryHighlights: (v: string) => void;
  prayerRequests: string;
  setPrayerRequests: (v: string) => void;
  supportNeeded: string;
  setSupportNeeded: (v: string) => void;
  canEdit: boolean;
  onOpenAi: () => void;
  reviewNotes?: string | null;
  showRevisionBanner?: boolean;
  onFieldChange?: () => void;
}

export const StepPeople: React.FC<StepPeopleProps> = ({
  ministryMonth,
  ministryYear,
  ministryHighlights,
  setMinistryHighlights,
  prayerRequests,
  setPrayerRequests,
  supportNeeded,
  setSupportNeeded,
  canEdit,
  onOpenAi,
  reviewNotes,
  showRevisionBanner,
  onFieldChange,
}) => {
  const ministryLabel = formatMinistryMonthLabel(ministryMonth, ministryYear);

  return (
    <div className="flex-1 min-h-0 overflow-y-auto px-4 py-5 space-y-5 animate-step-in">
      <div className="rounded-2xl bg-gradient-to-br from-amber-50 to-orange-50/50 border border-amber-100 px-4 py-4">
        <h2 className="text-lg font-bold text-gray-900">People &amp; story</h2>
        <p className="text-sm text-gray-600 mt-1">
          What did God do among your people in {ministryLabel}?
        </p>
        {canEdit && (
          <div className="mt-3">
            <AiAssistPill onClick={onOpenAi} />
          </div>
        )}
      </div>

      {showRevisionBanner && reviewNotes && (
        <RevisionNotesBanner notes={reviewNotes} />
      )}

      <NarrativeField
        label={`What did you see God do in ${ministryLabel}?`}
        value={ministryHighlights}
        onChange={(v) => {
          setMinistryHighlights(v);
          onFieldChange?.();
        }}
        disabled={!canEdit}
        rows={4}
      />

      <NarrativeField
        label="What should we pray about with you?"
        hint="Your network wants to stand with you in prayer."
        value={prayerRequests}
        onChange={(v) => {
          setPrayerRequests(v);
          onFieldChange?.();
        }}
        disabled={!canEdit}
        rows={3}
      />

      <NarrativeField
        label="How can your network help?"
        hint="Resources, connections, encouragement — anything that would help."
        value={supportNeeded}
        onChange={(v) => {
          setSupportNeeded(v);
          onFieldChange?.();
        }}
        disabled={!canEdit}
        rows={2}
      />
    </div>
  );
};
